<template>
  <div class="mobile-i18n-page">
    <s-w v-if="userInfo.businessType == 20"></s-w>
    <t-p-r v-else-if="userInfo.businessType == 10"></t-p-r>
    <div v-else>
      <!-- 你不是谈判人，申请成为谈判人，然后一个申请表单 -->
      <van-empty :description="$t('mobileBroker.notBroker')">
        <!-- 审核中 -->
        <!-- 申请成为谈判人 -->
        <van-button
          @click="onJump()"
          round
          type="danger"
          class="bottom-button"
          >{{
            userInfo.shopStatus == 0
              ? $t("mobileBroker.underReview")
              : $t("mobileBroker.apply")
          }}</van-button
        >
      </van-empty>
    </div>
  </div>
</template>
<script>
import CountBox from "@/components/CountBox.vue";
import { getUserInfoDetail } from "@/api/user";
import SW from "@/views/follow/sw/index1.vue";
import TPR from "@/views/follow/tpr/index1.vue";

export default {
  name: "Follow",
  components: {
    CountBox,
    SW,
    TPR,
  },
  data() {
    return {
      active: 0,
      isEdit: false,
      userInfo: {},
      clueList: [],
      preOrderList: [],
    };
  },
  computed: {},

  created() {
    this.getUserInfo();
  },
  methods: {
    async getUserInfo() {
      const response = await getUserInfoDetail();
      console.log("========返回userinfo======", response);
      if (response.code === 200) {
        this.userInfo = response.data.userInfo;
      }
    },
    onJump() {
      if (this.userInfo.shopStatus == 0) {
        // 正在审核中
        this.$toast(this.$t("mobileBroker.reviewing"));
      } else {
        this.$router.push("/applybroker");
      }
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped></style>
